import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AssignFilesCoursesService } from '../../../api/Services/maintenance/assign-files-courses.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { FileViewerComponent } from '../../common/file-viewer/file-viewer.component';
import { StudentTaskService } from '../../../api/Services/maintenance/student-task.service';

@Component({
  selector: 'app-student-course-task',
  templateUrl: './student-course-task.component.html',
  styleUrls: ['./student-course-task.component.css']
})
export class StudentCourseTaskComponent implements OnInit {

  @Input() data;


  public dataAssignFileStudetCourses:any[];
  public cou_vc_name :string;

  constructor(
    private dialog: MatDialog,
    private studentTaskService: StudentTaskService
  ) { }

  ngOnInit(): void {

    if (this.data.tabData.element) {
      this.cou_vc_name = this.data.tabData.element.cou_vc_name;
      this.get(this.data.tabData.element.cou_in_id, this.data.tabData.element.stu_bi_id);
    }
  }

  get(cou_in_id, stu_bi_id) {
    this.studentTaskService.GetStudentTaskModule(cou_in_id, stu_bi_id).subscribe(
      data => {
        console.log(data);

        if (data['sucess']) {
          let result = data['data'];
          console.log(result);
          this.dataAssignFileStudetCourses = result;
          
        }
        

      }
    );
  }

  viewerFile(element){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.data =  element.stta_vc_file_name;
    dialogConfig.minWidth = '50%';
    
    const dialogRef = this.dialog.open(FileViewerComponent,dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
 

  }
}
